.fpl-wrapper {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: var(--tg-theme-bg-color);
  z-index: 999999999;
}

.fpl-block-logo {
  position: absolute;
  top: 1.5rem;
  z-index: -1;

  &__img {
    max-width: 12rem;
    max-height: 16rem;
  }
}

.fpl-content {
  position: absolute;
  display: flex;
  // width: 12rem;
  height: 12rem;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  background-color: var(--tg-theme-bg-color);
  -webkit-box-shadow: 0px 0px 25px 30px var(--tg-theme-bg-color);
  -moz-box-shadow: 0px 0px 25px 30px var(--tg-theme-bg-color);
  box-shadow: 0px 0px 25px 30px var(--tg-theme-bg-color);
  user-select: none;
}

.fpl-actions {
  display: flex;
  flex-direction: column;
  height: 8rem;
  justify-content: space-around;
}

.fpl-block-info {
  display: flex;
  align-items: flex-end;
  position: absolute;
  top: 0rem;
  bottom: 1.5rem;
  font-size: 1.2rem;
  user-select: none;
  z-index: -1;
}
